import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
  getItem,
  updateItem,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { BILLING_INVOICES } from '../../data/billing-invoices';
import {
  BillingIntervalUpdateData,
  BillingInformation,
  Invoice,
  BillingInvoices,
} from '../../model/billing-invoice';
import { IBillingInvoicesApiService } from './billing-invoices-api.interface';
import { User } from '../../model/user';

@Injectable({
  providedIn: 'root',
})
export class BillingInvoicesMockApiService
  implements IBillingInvoicesApiService
{
  data = {
    billing_invoices: {
      items: [...BILLING_INVOICES],
      queryOptions: { page: 1, size: 10 } as QueryOptions<BillingInvoices>,
      subject: new BehaviorSubject<Maybe<BillingInvoices[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get billingInvoicesData() {
    return this.data['billing_invoices'] as Data<
      BillingInvoices,
      BillingInvoices
    >;
  }

  getBillingInvoices(
    userId: User['id'],
    options?: QueryOptions<Invoice>
  ): Observable<Maybe<BillingInvoices>> {
    return getItem(this.billingInvoicesData, userId);
  }
  updateBillingInterval(billing: BillingIntervalUpdateData): Observable<any> {
    return updateItem(this.billingInvoicesData, billing);
  }
}
